import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { ReactNode } from 'react';
import { NavigateFunction, useNavigate } from 'react-router';
import { NotFoundTranscription } from '../../../config/constants/transcription.constant';
import NotFound from '../../components/not-found.component';

const NotFoundPageContainer: React.FC = () => {
  const navigate: NavigateFunction = useNavigate();

  const handleChild = (): ReactNode => {
    return (
      <Button type='primary' icon={<HomeOutlined />} onClick={() => navigate('/')}>
        {NotFoundTranscription.NOT_FOUND_BUTTON_HOME_TEXT}
      </Button>
    );
  };

  return (
    <NotFound
      status='404'
      title={NotFoundTranscription.NOT_FOUND_TITLE}
      subTitle={NotFoundTranscription.NOT_FOUND_SUBTITLE}
      child={handleChild()}
    />
  );
};
export default NotFoundPageContainer;
